import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NewStudentRegisterWrapper } from './styled';
import { Spin, Divider, DatePicker } from 'antd';
import Input from 'components/Input/Input';
import Select from 'components/Select';
import images from 'assets/sheets/images';
import {
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  STATUS_OPTIONS,
  TIME_ZONE,
} from 'helper/init.constants';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import CustomTable from 'components/CustomTable/CustomTable';
import { toast } from 'sonner';
import CourseServices from 'services/CourseServices';
import InfoUserPopup, { paymentMethods } from './components/InfoUserPopup';
import NotePopup from './components/NotePopup';
import InvoicePopup from './components/InvoicePopup';
import dayjs from 'dayjs';
import { NO_INTERNET } from '../../components/messageError';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { clearAllFields } from 'pages/CourseSchedule';
import ChooseMonthDate from 'components/ChooseDate/ChooseMonthDate';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { checkStatusTransition, statusOptions } from './rules';
import PopupConfirm from './components/PopupConfirm';
import NewStudentRegisterModal from './components/NewStudentRegisterModal';
import CourseScheduleServices from 'services/CourseScheduleServices';

const initateForm = {
  search: '',
  courseScheduleId: 'ALL',
  eventId: 'ALL',
  type: 'NEW',
  status: 'ALL',
  page: DEFAULT_PAGE_NUMBER,
  pageSize: DEFAULT_PAGE_SIZE,
  startTime: '',
  endTime: '',
  timezone: TIME_ZONE,
  isAll: 0,
};

const detailUpdateInitate = {
  paymentDate: '',
  contactDate: '',
  bindingText: '',
  receiptRecipient: '',
};

const NewStudentRegister = () => {
  const [form, setForm] = useState({
    ...initateForm,
  });

  const [detailUpdate, setDetailUpdate] = useState({
    ...detailUpdateInitate,
  });
  const datePickerPaymentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [listCourseRegistration, setListCourseRegistration] = useState(null);
  const [course, setCourse] = useState([]);
  const [courseId, setCourseId] = useState(null);
  const [isAddNew, setIsAddNew] = useState(false);
  const [infoId, setInfoId] = useState(null);
  const [noteId, setNoteId] = useState(null);
  const [invoiceId, setInvoiceId] = useState(null);
  const [changeStatusConfirm, setChangeStatusConfirm] = useState({
    isPopup: false,
    courseId: null,
    status: null,
    beforeStatus: null,
    message: '',
  });

  const handleUpdateDetail = (_id, { label, value }) => {
    setDetailUpdate({
      ...detailUpdate,
      [label]: dayjs.isDayjs(value) ? value.format('YYYY-MM-DD') : value,
    });
    updateDetail(_id, {
      [label]: dayjs.isDayjs(value) ? value.format('YYYY-MM-DD') : value,
    });
  };

  const getListSchedules = async () => {
    return await CourseScheduleServices.getCourses({}).then((res) => {
      return {
        items: res.data.items.map((item, index) => ({
          ...item,
          key: item?._id || index,
        })),
      };
    });
  };

  const getListCourseRegistration = useCallback(async (params) => {
    setLoading(true);
    CourseScheduleRegistationServices.getCourseRegistration(clearAllFields(params))
      .then((res) => {
        setListCourseRegistration({
          ...res.data,
          items: res.data.items.map((item) => ({
            ...item,
          })),
        });
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  }, []);

  const getCourseRegistrationById = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getCourseRegistrationById()
      .then((res) => {
        setCourseId(res?.data?.items);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getCourseRegistrationById();
  }, []);

  useEffect(() => {
    const now = dayjs();
    getListCourseRegistration({
      ...form,
      startTime: now.subtract(1, 'year').format('YYYY-MM-DD'),
      endTime: '',
      type: 'NEW',
    });
  }, [getListCourseRegistration]);

  const pickNonEmptyFields = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([, value]) => value !== '' && value !== null && value !== undefined,
      ),
    );
  };

  const updateDetail = async (_id, detailUpdate) => {
    try {
      setLoading(true);
      const response = await CourseScheduleRegistationServices.updateCourseRegistration(
        _id,
        pickNonEmptyFields(detailUpdate),
      );

      if (response?.data) {
        const now = dayjs();
        await getListCourseRegistration({
          ...form,
          startTime: now.subtract(1, 'year').format('YYYY-MM-DD'),
          page: form.page || DEFAULT_PAGE_NUMBER,
          pageSize: form.pageSize || DEFAULT_PAGE_SIZE,
        });
      }
    } catch (err) {
      toast.error(err.message || NO_INTERNET);
    } finally {
      setLoading(false);
    }
  };

  function htmlToFormattedText(html, maxLength = 14) {
    return html?.replace(/<p>(.*?)<\/p>/g, (_, content) => {
      // giữ nguyên dòng <p><br></p>
      if (content.trim() === '<br>') return '<p><br></p>';

      let text = content.replace(/&nbsp;/g, ' ').trimStart();

      // cắt 14 ký tự
      text = text.length > 14 ? `${text.slice(0, maxLength)}...` : text;

      return `<p>${text}</p>`;
    });
  }
  const columns = [
    {
      title: '受付番号',
      dataIndex: 'receptionNumber',
      fixed: 'left',
      key: 'receptionNumber',
      width: 115,
    },
    {
      title: '開催ID',
      dataIndex: 'eventId',
      fixed: 'left',
      key: 'eventId',
      width: 111,
      render: (_, record) => {
        return <div>{record?.courseSchedules?.eventId}</div>;
      },
    },
    {
      title: '名前',
      dataIndex: 'name',
      fixed: 'left',
      key: 'name',
      width: 125,
      render: (_, record) => {
        return <div>{`${record.users.name}`}</div>;
      },
    },
    {
      title: 'アルファベット名',
      dataIndex: 'alphabetName',
      key: 'alphabetName',
      width: 151,
      render: (_, record) => {
        return <div>{record?.users?.alphabeticalName}</div>;
      },
    },
    {
      title: 'メールアドレス',
      dataIndex: 'email',
      key: 'email',
      width: 250,
      render: (_, record) => {
        return <div>{record?.users?.email}</div>;
      },
    },
    {
      title: '支払い方法',
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
      width: 145,
      render: (_, record) => {
        return (
          <div>
            {[
              {
                label: 'カード払い',
                value: 'CREDIT_CARD',
              },
              {
                label: '銀行振込',
                value: 'BANK_TRANSFER',
              },
              {
                label: 'PayPal',
                value: 'PAYPAL',
              },
              {
                label: '未定',
                value: 'UNDETERMINED',
              },
            ].find((item) => item.value === record?.paymentMethod)?.label || '未定'}
          </div>
        );
      },
    },
    {
      title: 'ステータス',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      render: (_, record) => {
        const getStatusStyle = (status) => {
          if (status === 'CANCELLATION_WAITING_LIST' || status === 'ADMIN_CANCELED') {
            return `!bg-[#FFF7E6] !text-[#FA8C16] !border-none`;
          }
          return `!bg-[#E6F7FF] !text-[#1890FF] !border-none`;
        };

        const currentStatus = record.status || statusOptions[0]?.value;
        const statusStyle = getStatusStyle(currentStatus);

        const handleStatusChange = async ({ value }) => {
          const courses = await getListSchedules();
          const detailCourse = courses?.items?.find(
            (r) => r.eventId === record?.courseSchedules?.eventId,
          );

          if (
            (currentStatus === 'CANCELLATION_WAITING_LIST' && value === 'WAITING_FOR_PAYMENT') ||
            value === 'PAYMENT_COMPLETED'
          ) {
            if (
              detailCourse &&
              Number(detailCourse.totalNewStudents) >= Number(detailCourse.newCapacity)
            ) {
              toast.error(
                '現在このコースは定員に達しています。定員数を変更するか、キャンセル処理を行ってから再試行してください',
              );
              return;
            }
          }

          const isResult = checkStatusTransition(currentStatus, value, record.paymentMethod);

          !isResult?.allow &&
            isResult.error &&
            toast.error(
              <div style={{ whiteSpace: 'pre-wrap', fontWeight: 500 }}>{isResult?.error}</div>,
            );

          isResult?.allow &&
            setChangeStatusConfirm({
              isPopup: isResult?.allow,
              courseId: record._id,
              status: value,
              beforeStatus: currentStatus,
              message: isResult?.message,
            });
        };

        return (
          <Select
            value={currentStatus}
            onChange={(e) => handleStatusChange({ value: e.value })}
            rounded={4}
            $width={170}
            $heightSelect={28}
            classNameLabel={statusStyle}
            className={`!h-7 max-w-[168px] !rounded-[4px] ${statusStyle} [&_.ant-select-selection-item]:flex [&_.ant-select-selection-item]:w-full [&_.ant-select-selection-item]:items-center [&_.ant-select-selection-item]:justify-between [&_.ant-select-selection-item]:text-inherit`}
            classNameSelect={`!h-7 min-w-[168px] !rounded-[4px] ${statusStyle} [&_.ant-select-selection-item]:flex [&_.ant-select-selection-item]:w-full [&_.ant-select-selection-item]:items-center [&_.ant-select-selection-item]:justify-between [&_.ant-select-selection-item]:text-inherit`}
            popupClassName="[&_.ant-select-item-option-selected]:bg-transparent [&_.ant-select-item-option-active]:bg-[#E6F7FF] [&_.ant-select-item]:text-inherit"
            suffixIcon={
              <div className="pointer-events-none ml-1">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-current"
                >
                  <path
                    d="M2 4.5L6 8.5L10 4.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            }
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ minWidth: '150px' }}
            bordered={false}
            showArrow={true}
            popupMatchSelectWidth={false}
            dropdownRender={(menu) => (
              <div className="rounded-[4px] border border-[#D9D9D9] bg-white py-1 shadow-sm">
                {menu}
              </div>
            )}
            isShowCurrent={true}
            options={statusOptions.map((op) =>
              op.value === 'WAITING_FOR_REGISTRATION'
                ? {
                    value: 'WAITING_FOR_REGISTRATION',
                    label: '最少催行達成待ち',
                  }
                : op,
            )}
          />
        );
      },
    },
    {
      title: '申込日',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 126,
      render: (_, record) => {
        return <div>{dayjs(record?.createdAt).format('YYYY/MM/DD')}</div>;
      },
    },
    {
      title: '支払日',
      dataIndex: 'paymentDate',
      key: 'paymentDate',
      width: 139,
      render: (_, record) => {
        return (
          <div className="relative">
            <DatePicker
              ref={datePickerPaymentRef}
              format="YYYY/MM/DD"
              placeholder=""
              width={140}
              getPopupContainer={(trigger) => {
                trigger.closest('.new-student-register') || document.body;
              }}
              className="-ml-3 flex h-[30px] w-[125px] justify-between rounded-[6px] border border-transparent p-0 pl-3 text-xs hover:border-transparent hover:bg-transparent"
              suffixIcon={
                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[#8C8C8C]">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.6667 2.33334H11.0833V1.16667C11.0833 0.891667 10.8583 0.666668 10.5833 0.666668C10.3083 0.666668 10.0833 0.891667 10.0833 1.16667V2.33334H3.91667V1.16667C3.91667 0.891667 3.69167 0.666668 3.41667 0.666668C3.14167 0.666668 2.91667 0.891667 2.91667 1.16667V2.33334H2.33333C1.41667 2.33334 0.666667 3.08334 0.666667 4V12.25C0.666667 13.1667 1.41667 13.9167 2.33333 13.9167H11.6667C12.5833 13.9167 13.3333 13.1667 13.3333 12.25V4C13.3333 3.08334 12.5833 2.33334 11.6667 2.33334ZM12.25 12.25C12.25 12.525 12.025 12.75 11.75 12.75H2.33333C2.05833 12.75 1.83333 12.525 1.83333 12.25V5.5H12.25V12.25Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              }
              allowClear={false}
              value={record.paymentDate ? dayjs(record.paymentDate, 'YYYY/MM/DD') : null}
              onChange={(date, dateString) => {
                // Handle both calendar selection and manual input
                if (date && date.isValid()) {
                  handleUpdateDetail(record._id, {
                    label: 'paymentDate',
                    value: dateString,
                  });
                }
              }}
              onBlur={() => {
                datePickerPaymentRef.current?.blur();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handlePressEnter(e, record);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: '入金後連絡',
      dataIndex: 'depositDate',
      key: 'depositDate',
      width: 127,
      render: (_, record) => {
        return (
          <div className="relative">
            <DatePicker
              format="YYYY/MM/DD"
              placeholder=""
              getPopupContainer={(trigger) => {
                trigger.closest('.new-student-register') || document.body;
              }}
              className="-ml-3 flex h-[30px] w-[125px] justify-between rounded-[6px] border border-transparent p-0 pl-3 text-xs hover:border-transparent hover:bg-transparent"
              suffixIcon={
                <span className="absolute right-2 top-1/2 -translate-y-1/2 pl-2 text-[#8C8C8C]">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.6667 2.33334H11.0833V1.16667C11.0833 0.891667 10.8583 0.666668 10.5833 0.666668C10.3083 0.666668 10.0833 0.891667 10.0833 1.16667V2.33334H3.91667V1.16667C3.91667 0.891667 3.69167 0.666668 3.41667 0.666668C3.14167 0.666668 2.91667 0.891667 2.91667 1.16667V2.33334H2.33333C1.41667 2.33334 0.666667 3.08334 0.666667 4V12.25C0.666667 13.1667 1.41667 13.9167 2.33333 13.9167H11.6667C12.5833 13.9167 13.3333 13.1667 13.3333 12.25V4C13.3333 3.08334 12.5833 2.33334 11.6667 2.33334ZM12.25 12.25C12.25 12.525 12.025 12.75 11.75 12.75H2.33333C2.05833 12.75 1.83333 12.525 1.83333 12.25V5.5H12.25V12.25Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              }
              allowClear={false}
              value={record.contactDate ? dayjs(record.contactDate, 'YYYY/MM/DD') : null}
              onChange={(date, dateString) => {
                // Handle both calendar selection and manual input
                if (date && date.isValid()) {
                  handleUpdateDetail(record._id, {
                    label: 'contactDate',
                    value: dateString,
                  });
                }
              }}
              onBlur={() => {
                // Blur handling if needed
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handlePressEnter(e, record);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: '製本テキスト',
      dataIndex: 'bookingBlinding',
      key: 'bookingBlinding',
      width: 150,
      render: (_, record) => (
        <div className="flex items-center justify-center">
          <Select
            options={[
              {
                value: 'SENT',
                label: '送付済み',
              },
              {
                value: 'PURCHASE',
                label: '購入する',
              },
            ]}
            value={record.bindingText}
            width={118}
            height={28}
            className={'!w-[245px]'}
            classNameSelect="!rounded-[2px] !h-7 min-w-[100px] gap-1 !border-none !hover:bg-[#f5f5f5] !hover:border-[#f5f5f5]"
            classNameSelectRow="!gap-4"
            classNameLabel="!w-[58px]"
            onChange={(e) =>
              handleChangeData({
                id: record._id,
                label: 'bindingText',
                value: e.value,
              })
            }
            iconDown={images.icon.src}
          />
        </div>
      ),
    },
    {
      title: '領収書',
      dataIndex: 'receiptRecipient',
      key: 'receiptRecipient',
      width: 150,
      render: (_, record) => (
        <div className="flex items-center justify-center">
          <Select
            options={[
              {
                value: 'REQUEST',
                label: '発行希望',
              },
              {
                value: 'ALREADY_ISSUED',
                label: '発行済み',
              },
            ]}
            value={record.receiptRecipient || ''}
            width={118}
            height={28}
            className={'!w-[245px]'}
            classNameSelect="!rounded-[2px] min-w-[100px] !h-7 gap-1 !border-none !hover:bg-[#f5f5f5]"
            classNameSelectRow="!gap-2"
            classNameLabel="!w-[58px]"
            onChange={(e) =>
              handleChangeData({
                id: record._id,
                label: 'receiptRecipient',
                value: e.value,
              })
            }
            iconDown={images.icon.src}
          />
        </div>
      ),
    },
    {
      title: '備考',
      dataIndex: 'notes',
      key: 'notes',
      width: 245,
      render: (_, record) => {
        if (!record.notes) return null;

        return (
          <div
            className="max-w-[230px]"
            title={record?.invoice}
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{ __html: htmlToFormattedText(record?.notes) }}
          />
        );
      },
    },
    {
      title: '請求書',
      dataIndex: 'invoice',
      key: 'invoice',
      width: 245,
      render: (_, record) => {
        return (
          <div
            className="max-w-[230px]"
            title={record?.invoice}
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{ __html: htmlToFormattedText(record?.invoice) }}
          />
        );
      },
    },
    {
      title: 'アクション',
      dataIndex: 'action',
      key: 'action',
      width: 163,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <div
            onClick={() => handleOpenPopupNote(record)}
            className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
          >
            <images.taskEdit.src />
          </div>
          <div
            onClick={() => handleOpenPopupInvoice(record)}
            className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
          >
            <images.currency.src />
          </div>
          <div
            onClick={() => setInfoId(record?._id)}
            className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
          >
            <images.eyeStudent.src />
          </div>
        </div>
      ),
    },
  ];

  const handleOpenPopupInvoice = (record) => {
    setInvoiceId(record?._id);
  };

  const handleOpenPopupNote = (record) => {
    setNoteId(record?._id);
  };

  const handlePressEnter = (e, record) => {
    const inputValue = e.target.value.trim();
    const parsed = dayjs(inputValue, 'YYYY/MM/DD', true);

    if (parsed.isValid()) {
      handleUpdateDetail(record._id, {
        label: 'paymentDate',
        value: parsed.format('YYYY/MM/DD'),
      });
    } else {
      e.target.value = '';
      e.target.blur();
    }
  };

  const getCourses = () =>
    CourseServices.getCourses({})
      .then((res) =>
        setCourse(
          res.data
            .map((item) => ({
              value: item._id,
              label: item.name,
            }))
            .map((i) =>
              i.label === 'インテグレーティッドトレーニング'
                ? {
                    value: i.value,
                    label: 'インテグレーティッド',
                  }
                : i,
            ),
        ),
      )
      .catch((err) => toast.error(err.message || NO_INTERNET));

  useEffect(() => {
    getCourses();
  }, []);

  const handleChangeData = ({ label, value, id }) => {
    setForm({
      ...form,
      [label]: value,
    });
    if (id) {
      updateDetail(id, {
        ...detailUpdate,
        [label]: dayjs.isDayjs(value) ? value.format('YYYY-MM-DD') : value,
      });
    }
  };

  const handleSearch = () => {
    setForm({
      ...form,
      page: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
      type: 'NEW',
    });

    const now = dayjs();

    getListCourseRegistration(
      clearAllFields({
        ...form,
        page: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        startTime: form.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
        endTime: form.endTime || '',
        type: 'NEW',
      }),
    );
  };

  const handleDateChange = (dates) => {
    if (!dates || !dates[0] || !dates[1]) {
      setForm((prev) => ({
        ...prev,
        startTime: '',
        endTime: '',
        dateStart: null,
        dateEnd: null,
      }));
      return;
    }

    const startDate = dates[0].startOf('month');
    const endDate = dates[1].endOf('month');

    setForm((prev) => ({
      ...prev,
      startTime: startDate.format('YYYY-MM-DD'),
      endTime: endDate.format('YYYY-MM-DD'),
      dateStart: startDate,
      dateEnd: endDate,
    }));
  };

  const handleChangePage = (page, pageSize) => {
    const now = dayjs();
    const body = clearAllFields({
      ...form,
      type: 'NEW',
      startTime: form.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
      endTime: form.endTime || '',
      page,
      pageSize,
    });

    setForm(body);
    getListCourseRegistration(body);
  };

  const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const buildExportParams = (baseForm, type) => {
    const now = dayjs();
    const body = clearAllFields({
      ...baseForm,
      startTime: baseForm.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
      type,
      isAll: 1,
    });
    if (body.courseId === 'ALL') delete body.courseId;
    if (body.courseScheduleId === 'ALL') delete body.courseScheduleId;
    if (body.status === 'ALL') delete body.status;
    return body;
  };

  const handleExportData = async () => {
    setLoading(true);
    try {
      const body = buildExportParams(form, 'NEW');
      const res = await CourseScheduleRegistationServices.getCourseRegistration(body, {
        timeout: 120000,
      });
      const items = Array.isArray(res?.data?.items)
        ? res.data.items
        : Array.isArray(res?.data)
          ? res.data
          : [];

      if (items.length === 0) {
        toast.error('No data to export');
        return;
      }

      const dataExport = items.map((item) => ({
        受付番号: item.receptionNumber,
        開催ID: item.courseSchedules?.eventId || '',
        名前: item.users?.name || '',
        アルファベット名: item.users?.alphabeticalName || '',
        メールアドレス: item.users?.email || '',
        支払い方法: paymentMethods.find((p) => p.label === item.paymentMethod)?.value,
        ステータス: STATUS_OPTIONS.find((option) => option.value === item.status)?.label,
        申込日: `="${dayjs(item.createdAt).format('YYYY/MM/DD')}"`,
        支払日: item.paymentDate ? `="${dayjs(item.paymentDate).format('YYYY/MM/DD')}"` : '',
        入金後連絡: item.contactDate ? `="${dayjs(item.contactDate).format('YYYY/MM/DD')}"` : '',
        製本テキスト:
          [
            {
              value: 'SENT',
              label: '送付済み',
            },
            {
              value: 'PURCHASE',
              label: '購入する',
            },
          ].find((option) => option.value === item.bindingText)?.label || '',
        領収書:
          [
            {
              value: 'REQUEST',
              label: '発行希望',
            },
            {
              value: 'ALREADY_ISSUED',
              label: '発行済み',
            },
          ].find((option) => option.value === item.receiptRecipient)?.label || '',
        備考: stripHtml(item.notes),
        請求書: stripHtml(item.invoice),
      }));

      const headers = [
        '受付番号',
        '開催ID',
        '名前',
        'アルファベット名',
        'メールアドレス',
        '支払い方法',
        'ステータス',
        '申込日',
        '支払日',
        '入金後連絡',
        '製本テキスト',
        '領収書',
        '備考',
        '請求書',
      ];

      const ws = XLSX.utils.json_to_sheet(dataExport.length > 0 ? dataExport : [], {
        header: headers,
      });

      ws['!cols'] = [
        { wch: 12 }, // 受付番号
        { wch: 15 }, // 開催ID
        { wch: 25 }, // 名前
        { wch: 12 }, // アルファベット名
        { wch: 12 }, // メールアドレス
        { wch: 15 }, // 支払い方法
        { wch: 20 }, // ステータス
        { wch: 20 }, // 申込日
        { wch: 15 }, // 支払日
        { wch: 12 }, // 入金後連絡
        { wch: 20 }, // 製本テキスト
        { wch: 20 }, // 領収書
        { wch: 20 }, // 備考
        { wch: 20 }, // 請求書
      ];

      // Force date columns as text format
      if (ws['!ref']) {
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cell_address = XLSX.utils.encode_cell({ c: C, r: R });
            if (!ws[cell_address]) continue;

            // 申込日(7), 支払日(8), 入金後連絡(9)
            if (C === 7 || C === 8 || C === 9) {
              if (!ws[cell_address].s) ws[cell_address].s = {};
              ws[cell_address].s.numFmt = '@';
              ws[cell_address].t = 's';
            }
          }
        }
      }

      // Convert to CSV
      const csv = XLSX.utils.sheet_to_csv(ws, {
        FS: ',',
        strip: false,
      });

      const BOM = '\uFEFF';

      const blob = new Blob([BOM + csv], {
        type: 'text/csv;charset=utf-8;',
      });

      saveAs(blob, `newStudentRegister.csv`);
      toast.success('ダウンロードしました');
    } catch (err) {
      toast.error(typeof err === 'string' ? err : err?.message || NO_INTERNET);
    } finally {
      setLoading(false);
    }
  };

  return (
    <NewStudentRegisterWrapper>
      <style>{`
        .desktop-filter-1920 {
          display: none;
        }
        .mobile-filter-1920 {
          display: block;
        }
        
        @media (min-width: 1537px) {
          .desktop-filter-1920 { 
            display: flex !important; 
            align-items: center;
            justify-content: flex-end !important;
            gap: 16px !important;
            height: 40px !important;
          }
          .mobile-filter-1920 { 
            display: none !important; 
          }
        }
        
        @media (max-width: 1537px) {
          .desktop-filter-1920 { 
            display: none !important; 
          }
          .mobile-filter-1920 { 
            display: flex !important;
          }
        }
      `}</style>
      <Spin spinning={loading}>
        <div className="mb-4">
          {/* Desktop layout (1920px and above) - single row */}
          <div className="desktop-filter-1920">
            <Input
              placeholder="受付番号、名前、メールアドレス"
              $autoTrim={true}
              widthInput={280}
              height={40}
              value={form.search}
              onChange={(e) => handleChangeData({ label: 'search', value: e })}
            />
            <Select
              label="コース:"
              options={[
                {
                  value: 'ALL',
                  label: '全て',
                },
                ...course,
              ]}
              value={form.courseId || 'ALL'}
              $width={180}
              isPopup={false}
              $widthLabel={80}
              $height={40}
              onChange={(e) => handleChangeData({ label: 'courseId', value: e.value })}
              iconDown={images.icon.src}
            />
            <Select
              label="開催ID:"
              options={[
                {
                  value: 'ALL',
                  label: '全て',
                },
                ...(courseId?.map((item) => ({
                  value: item._id,
                  label: item.eventId,
                })) || []),
              ]}
              $widthLabel={136}
              value={form.courseScheduleId || 'ALL'}
              isPopup={false}
              $width={180}
              $height={40}
              onChange={(e) =>
                handleChangeData({
                  label: 'courseScheduleId',
                  value: e.value,
                })
              }
              iconDown={images.icon.src}
            />
            <Select
              label="ステータス:"
              options={[...STATUS_OPTIONS]}
              value={form.status || '全て'}
              isPopup={false}
              $width={220}
              $height={40}
              classNameSelectRow="!gap-4"
              onChange={(e) => handleChangeData({ label: 'status', value: e.value })}
              iconDown={images.icon.src}
            />
            <div className="flex w-[256px] items-center gap-4">
              <span className="text-nowrap font-normal">日程：</span>
              <div className="w-[200px]">
                <ChooseMonthDate
                  value={form.dateStart && form.dateEnd ? [form.dateStart, form.dateEnd] : null}
                  onChange={handleDateChange}
                />
              </div>
            </div>
            <Button width={84} height={40} btnType="outline" onClick={handleSearch}>
              <p style={{ letterSpacing: '0', fontSize: 14 }}>検索</p>
            </Button>
          </div>

          <div className="mobile-filter-1920 gap-4 xl:flex xl:flex-col 2xl:flex 2xl:flex-col">
            <div className="flex justify-end">
              <Input
                placeholder="受付番号、名前、メールアドレス"
                $autoTrim={true}
                widthInput={280}
                height={40}
                value={form.search}
                onChange={(e) => handleChangeData({ label: 'search', value: e })}
              />
            </div>
            <div className="flex items-center justify-end gap-4">
              <Select
                label="コース:"
                options={[
                  {
                    value: 'ALL',
                    label: '全て',
                  },
                  ...course,
                ]}
                value={form.courseId || 'ALL'}
                $width={180}
                $height={40}
                isPopup={false}
                classNameSelect="w-[120px]"
                classNameLabel="!w-[60px]"
                onChange={(e) => handleChangeData({ label: 'courseId', value: e.value })}
                iconDown={images.icon.src}
              />
              <Select
                label="開催ID:"
                options={[
                  {
                    value: 'ALL',
                    label: '全て',
                  },
                  ...(courseId?.map((item) => ({
                    value: item._id,
                    label: item.eventId,
                  })) || []),
                ]}
                $widthLabel={136}
                value={form.courseScheduleId || 'ALL'}
                isPopup={false}
                classNameSelect="w-[120px]"
                classNameLabel="!min-w-[50px]"
                $width={180}
                $height={40}
                onChange={(e) =>
                  handleChangeData({
                    label: 'courseScheduleId',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />
              <Select
                label="ステータス:"
                options={[...STATUS_OPTIONS]}
                value={form.status || '全て'}
                isPopup={false}
                $width={180}
                $height={40}
                classNameSelect="w-[120px]"
                classNameLabel="!min-w-[80px]"
                classNameSelectRow="!gap-4"
                onChange={(e) => handleChangeData({ label: 'status', value: e.value })}
                iconDown={images.icon.src}
              />
              <div className="flex w-[256px] items-center gap-4">
                <span className="text-nowrap font-normal">日程：</span>
                <div className="w-[200px]">
                  <ChooseMonthDate
                    value={form.dateStart && form.dateEnd ? [form.dateStart, form.dateEnd] : null}
                    onChange={handleDateChange}
                  />
                </div>
              </div>
              <Button width={84} height={40} btnType="outline" onClick={handleSearch}>
                <p style={{ letterSpacing: '0' }}>検索</p>
              </Button>
            </div>
          </div>
        </div>
        <Divider className="mb-4" />

        <div className="mb-4 flex items-center justify-between">
          <Button btnType="primary" width={120} height={40} onClick={() => setIsAddNew(true)}>
            <p style={{ letterSpacing: '0' }}>個別追加</p>
          </Button>
          <Button width={160} height={40} btnType="back" onClick={handleExportData}>
            <p
              style={{
                letterSpacing: '0',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <images.download.src width={20} height={20} />
              ダウンロード
            </p>
          </Button>
        </div>

        <CustomTable
          rowKey={'_id'}
          columns={columns}
          dataSource={listCourseRegistration?.items || []}
          scrollX={1200}
          sticky={{ offsetHeader: 0 }}
        />

        <div className="mt-6 flex w-full items-center justify-end">
          <Pagination
            total={listCourseRegistration?.count || 0}
            pageSize={form.pageSize || DEFAULT_PAGE_SIZE}
            page={form.page || DEFAULT_PAGE_NUMBER}
            onChangePage={handleChangePage}
          />
        </div>

        <InfoUserPopup isOpen={!!infoId} onCancel={() => setInfoId(null)} infoId={infoId} />

        <NotePopup
          isOpen={!!noteId}
          onCancel={() => setNoteId(null)}
          noteId={noteId}
          onSuccess={() => getListCourseRegistration(form)}
        />
        <InvoicePopup
          isOpen={!!invoiceId}
          onCancel={() => setInvoiceId(null)}
          onSuccess={() => {
            getListCourseRegistration(form);
          }}
          invoiceId={invoiceId}
        />

        <PopupConfirm
          isOpen={!!changeStatusConfirm.courseId}
          onCancel={() => setChangeStatusConfirm({})}
          courseId={changeStatusConfirm?.courseId}
          status={changeStatusConfirm?.status}
          message={changeStatusConfirm?.message}
          beforeStatus={changeStatusConfirm?.beforeStatus}
          onSuccess={() => getListCourseRegistration(form)}
        />

        <NewStudentRegisterModal
          courseId={isAddNew}
          isOpen={isAddNew}
          onCancel={() => setIsAddNew(false)}
          onSuccess={() => {
            setForm({ ...initateForm });
            const now = dayjs();
            getListCourseRegistration({
              startTime: now.subtract(1, 'year').format('YYYY-MM-DD'),
              type: 'NEW',
              search: '',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
            });
          }}
        />
      </Spin>
    </NewStudentRegisterWrapper>
  );
};

export default NewStudentRegister;
